import $ from 'jquery';

window.jQuery = $;
window.$ = $;
window.jquery = $;
